export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/admin-4a84ce58d77df560efd1854c8efa2e8a.jpg";